import type { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import { base } from 'nextjs/getServerSideProps';
import type { Props } from 'nextjs/getServerSideProps';
import PageNextJs from 'nextjs/PageNextJs';

import ContractVerification from 'ui/pages/ContractVerification';

const Page: NextPage<Props> = (props: Props) => {
  return (
    <PageNextJs pathname="/contract-verification" query={ props.query }>
      <ContractVerification/>
    </PageNextJs>
  );
};

export default Page;

// export { base as getServerSideProps } from 'nextjs/getServerSideProps';

export const getServerSideProps = async(context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, [ 'common' ])),
      ...(await base(context)),
    },
  };
};
